import { createReducer, on, createFeatureSelector, createSelector } from '@ngrx/store';
import { Pagination } from '../models/pagination.model';
import { setProcesses, resetProcesses } from '../actions/processes.actions';
import { Process } from '../models/process.model';

export const initialState: Pagination<Process> = null;

const reducer = createReducer(initialState,
  on(setProcesses, (state, processes) => processes),
  on(resetProcesses, () => initialState),
);

export const fromProcesses = {
  selectProcessesState: createFeatureSelector<Pagination<Process>>('processes'),
};

export function processesReducer(state, action) {
  return reducer(state, action);
}
